/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateClientsConfigurationDto } from './createClientsConfigurationDto';


export interface CreateAgencyGroupDto { 
    name: string;
    /**
     * Company ID for the agency
     */
    agency: string;
    /**
     * Activate this config group
     */
    isActive: boolean;
    /**
     * Use all clients of the agency
     */
    allClients?: boolean;
    /**
     * Use those selected clients only
     */
    clients?: Array<CreateClientsConfigurationDto>;
    /**
     * Role IDs for this groups
     */
    roles?: Array<string>;
}

